import { useEffect } from 'react';

import { init } from '@/utils/analytics';
import { useTheme } from '@/theme';

export default function AnalyticsProvider() {
    const theme = useTheme();

    function initAnalytics() {
        init(theme.customJSON.googleAnalyticsId, theme.customJSON.amplitudeKey);
    }

    useEffect(() => {
        try {
            window['ariseInitAnalytics'] = initAnalytics;
            initAnalytics();

            // Listen for analytics consent changes
            window['cbsoptanon']?.ot?.addOnConsentChangedHandler(initAnalytics);
        } catch {}
    }, [theme]);
    return <></>;
}
